import { PrismicRichText } from '@prismicio/react'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { FC } from 'react'
import { PrismicStructuredTextType } from 'src/typings/generated/graphql'
import CustomLink from 'src/utils/customLink'
import * as Styles from './storyCarouselCard.module.scss'

export type StoryCarouselCardProps = {
  className?: string
  image: IGatsbyImageData
  imageAlt?: string
  title: string
  body?: PrismicStructuredTextType
}

export const StoryCarouselCard: FC<StoryCarouselCardProps> = ({
  className,
  image,
  imageAlt,
  title,
  body,
}) => {
  return (
    <div className={`${Styles.storyCarouselCard} ${className ?? ''}`}>
      <GatsbyImage
        image={image}
        alt={imageAlt ?? ''}
        className={Styles.image}
      />
      <div className={Styles.content}>
        <h3 className={Styles.title}>{title}</h3>
        {body && (
          <div className={Styles.body}>
            <PrismicRichText
              field={body.richText}
              components={{
                hyperlink: ({ node, children }: any) =>
                  CustomLink({ link: node.data, children }),
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
